import Player from '@vimeo/player';
import { csrfToken } from 'rails-ujs';

let movieId = null; // 動画IDを保持
let loggedId = null; // 閲覧履歴IDを保持
let player = null; // vimeoプレイヤーのインスタンスを保持
let preview = (location.href.match(/key/)) ? true : false; // previewキーの有無
let interval = 10 * 1000; // 更新インターバル
let timerId = null; // タイマー識別子

$(document).ready(function () {
  initialize();

  // サンプル視聴ボタンクリック時
  $('.paid_play').on('click', function () {
    $(`#div_paid_${movieId}`).hide();
    player.play();
  });

  // 目次クリック時
  $('.toc_time').on('click', function (e) {
    e.preventDefault();
    const time = $(this).data('time');
    const times = time.split(':');
    let second = 0;
    if (times.length === 2) {
      second = (+times[0]) * 60 + (+times[1]);
    } else if (times.length === 3) {
      second = (+times[0]) * 60 * 60 + (+times[1]) * 60 + (+times[2]);
    }
    player.setCurrentTime(second);
  });
});

function initialize() {
  movieId = $('iframe[id^=player]').data('movie_id');
  player = new Player(`player_${movieId}`);

  // 再生位置設定
  player.setCurrentTime(Number($('#current_time').val()));

  // イベントリスナー設定
  window.addEventListener('beforeunload', () => {
    player.pause();
  });
  window.addEventListener('pagehide', () => {
    player.pause();
  });

  // 再生を開始した時
  player.on('play', function(){
    createLogData();
    clearTimer();
    setTimer();
  });

  // 再生を一時停止した or 再生が終了した時
  player.on('pause', function(){
    const $div_paid = $(`#div_paid_${movieId}`);
    if ($div_paid.get(0)) {
      $div_paid.show();
    }

    updateLogData();
    clearTimer();
  });
}

function setTimer() {
  timerId = setInterval(updateLogData, interval);
}

function clearTimer() {
  if (!timerId) return;
  clearInterval(timerId);
  timerId = null;
}

function createLogData() {
  // 一度送信済み or プレビュー表示の場合は送信しない
  if (loggedId || preview) return;

  $.ajax({
    type: 'POST',
    url: '/api/log_movies',
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    data: {
      'movie_id': movieId
    },
    success: function (data) {
      loggedId = data['log_id'];
    },
    async: false,
    timeout: 10000,
  });
}

function updateLogData() {
  if (player == null || loggedId == null || preview) return;

  player.getPlayed().then(function(played) {
    if (played == null) return;
    if (played.length == 0) return;
    const durations = played.map((range) => {
      // 再生時間 = 停止位置 - 開始位置
      const duration = range[1] - range[0];
      return duration;
    });
    const endPoints = played.map((range) => {
      // 停止位置
      return range[1];
    });
    const duration = durations.reduce((sum, duration) => { return sum + duration; }, 0);
    const currentTime = Math.max(...endPoints);

    $.ajax({
      type: 'PUT',
      url: `/api/log_movies/${loggedId}`,
      headers: {
        'X-CSRF-Token': csrfToken()
      },
      data: {
        'duration': duration,
        'current_time': currentTime
      },
      async: false,
      timeout: 10000,
    });
  });
}
